import { Button, Popconfirm, Popover, Row, Space, Table } from "antd";
import React, { useEffect, useState, useRef, useMemo } from "react";
import "./Received.scss";
import { ReactComponent as ListIconSVG } from "assets/images/svg/List.svg";
import { ButtonExcel, ExpandSearch, ListActionButton } from "components/common";
import {
  NewExamBillBtn,
  NewPatientBtn,
  allColumns,
  dataFields,
} from "./config";
import { medicalExaminationService, receiveService } from "api";
import ColumnPopoverDisplay from "components/common/PopoverTable/PopoverTable";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { FORMAT_TIME, tabKeys } from "types/enums";
import {
  setActiveKey,
  setButtonsHeader,
  setIdPhieuKham,
} from "redux/reducer/common";
import { setAction, setAnh } from "redux/reducer/receive";
import { RECEIVE_ACTION_TYPE } from "types/enums/receive-action-type";
import Notification from "components/common/notification/notification";
import {
  convertIosStringToDateDayjs,
  exportFile,
  formatDateToString,
  getTableOptions,
  saveTableOptions,
} from "helper/common";
import { CalendarSVG, CalendarSelectedSVG, RecycleSVG } from "assets";
import dayjs from "dayjs";
import { setPatientRecord } from "redux/reducer/patientRecord";
import ExanRegBill from "./components/ExamRegBill/ExamRegBill";
import { sharedDirectory } from "api";
import CustomResizableTable from "components/common/CustomResizableTable/CustomResizableTable";
import { ColumnsEdit } from "types/models/column-table-edit";

const Received = () => {
  let savedTableOption = getTableOptions(
    "RECEIVED_TABLE",
    localStorage.getItem("username")
  );
  const dataPassing = useAppSelector((state) => state.receive.dataPassing);
  const [loading, setLoading] = useState<boolean>(true);
  const [data, setData] = useState<any[]>();

  // );
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  const tinh = useAppSelector((e) => e.receiveReload.tinh);
  const huyen = useAppSelector((e) => e.receiveReload.huyen);
  const xa = useAppSelector((e) => e.receiveReload.xa);
  const idPhieuKham = useAppSelector((e) => e.common.idPhieuKham);

  const [selectedBtn, setSelectedBtn] = useState<number | null>(1);
  const expandRef = useRef<any>();
  const [limit, setLimit] = useState(100);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [isOpenDate, setIsOpenDate] = useState<boolean>(false);
  const [fields, setFields] = useState(dataFields(onOpenChange));
  const [params, setParams] = useState<any>({
    ngayTaoDen: dayjs(),
    ngayTaoTu: dayjs(),
  });
  const defaultColumns = savedTableOption
    ? allColumns.map((cl) => {
        if (savedTableOption.some((it) => it.dataIndex === cl.dataIndex)) {
          let tmp = savedTableOption.find(
            (it) => it.dataIndex === cl.dataIndex
          );
          return {
            ...cl,
            show: true,
            width: tmp?.width ?? null,
          };
        } else
          return {
            ...cl,
            show: false,
          };
      })
    : allColumns;
  const [columns, setColumns] = useState<ColumnsEdit>(
    defaultColumns.filter((e) => e.show == true)
  );

  useEffect(() => {
    if (columns.find((e) => e.dataIndex == "STT")) {
      columns.find((e) => e.dataIndex == "STT").render = (
        text,
        record,
        index
      ) => {
        const rowNumber = (page - 1) * limit + index + 1;
        return rowNumber;
      };
    }
    if (columns.find((e) => e.dataIndex == "Action")) {
      columns.find((e) => {
        if (e.dataIndex === "Action") {
          e.render = (
            value,
            _record: {
              idPhieuKham: number;
              trangThai: number | string;
              id: number;
            },
            index
          ) => {
            return (
              <ListActionButton
                editFunction={() => handleEdit(_record)}
                printFunction={() => handlePrint(_record.id)}
              >
                <Popconfirm
                  className="danger-confirm"
                  title={`Đồng ý ${
                    _record["trangThai"] == 0 ? "xóa thông tin" : "hủy khám"
                  }`}
                  onConfirm={() => {
                    if (_record?.trangThai == 0) {
                      postStatusDiagnoseForm(_record.id, 7);
                    } else {
                      postStatusDiagnoseForm(_record.id, 6);
                    }
                  }}
                >
                  <Button type="text" icon={<RecycleSVG />} />
                </Popconfirm>
              </ListActionButton>
            );
          };
        }
      });
    }
  }, [columns]);

  function onOpenChange(open) {
    setIsOpenDate(open);
  }

  useMemo(() => {
    fields.find((e) => {
      if (e.name === "ngaySinh") {
        if (isOpenDate) {
          e.optionsTime = {
            showTime: false,
            format: FORMAT_TIME.dayFullInput,
          };
        } else {
          e.optionsTime = {
            showTime: false,
            format: FORMAT_TIME.dayFull,
          };
        }
      }
    });
  }, [isOpenDate]);

  //thiết laajo giá trị cho field
  const postStatusDiagnoseForm = async (id, trangThai) => {
    setLoading(true);
    try {
      const params = {
        id: id,
        status: trangThai,
      };
      medicalExaminationService.deleteMedicalBill(params);
      fetchData();

      let message = "";

      if (trangThai == 6) {
        message = "Đã cập nhật phiếu thành trạng thái Hủy thực hiện";
      }
      if (trangThai == 7) {
        message = "Đã xóa thông tin phiếu";
      }

      Notification("success", message);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã có lỗi xảy ra");
    }
  };

  //gọi api chin tiết BN

  const getPKById = async (id) => {
    try {
      const res = await receiveService.getPKById(id);

      dispatch(
        setAction({
          actionType: RECEIVE_ACTION_TYPE.EDITPHIEUKHAM,
          dataPassing: {
            ...res,
            // ngaySinh: convertIosStringToDateDayjs(res?.ngaySinh),
          },
        })
      );
    } catch (error) {
      Notification("error", "Lỗi ");
    }
  };

  const handleEdit = (record) => {
    dispatch(setIdPhieuKham(record.id));
    dispatch(setAnh(record.anh));
    dispatch(
      setPatientRecord({
        selected: true,
        record: record,
      })
    );
    if (record?.id) {
      getPKById(record.id);
      dispatch(setActiveKey(tabKeys.RECEIVE.TAB_2));
    } else {
      dispatch(
        setAction({
          actionType: RECEIVE_ACTION_TYPE.EDITPHIEUKHAM,
          dataPassing: record,
        })
      );
      dispatch(setActiveKey(tabKeys.RECEIVE.TAB_2));
    }
  };
  const handlePrint = (id) => {
    dispatch(setIdPhieuKham(id));
    modalRef.current.setIdPK(id);
    modalRef?.current.openModal();
  };

  useEffect(() => {
    if (tinh) {
      fetchDistricts(tinh);
    }
  }, [tinh]);
  useEffect(() => {
    if (huyen) {
      fetchCommunes(huyen);
    } else {
      expandRef.current.resetFieldOutHuyen();
    }
  }, [huyen]);

  useEffect(() => {
    if (xa) {
      fetchCommunes(xa);
    } else {
      expandRef.current.resetFieldOutXa();
    }
  }, [xa]);
  const fetchProvinces = async () => {
    try {
      let response = await sharedDirectory.getListProvince();
      const options = response.data.map((e) => ({
        value: e.id,
        label: e.name,
      }));
      localStorage.setItem("listCommueNew", JSON.stringify(options));
      fields.find((e) => e.name === "tinh").options = options;
      setFields([...fields]);
    } catch (err) {}
  };
  const fetchDistricts = async (provinceId) => {
    try {
      let response = await sharedDirectory.getListDistrict({
        provinceId: provinceId,
      });
      const options = response.data.map((e) => ({
        value: e.id,
        label: e.name,
      }));
      fields.find((e) => e.name === "huyen").options = options;
      setFields([...fields]);
    } catch (err) {}
  };

  const fetchCommunes = async (districtId) => {
    try {
      let response = await sharedDirectory.getListCommune({
        districtId: districtId,
      });
      const options = response.data.map((e) => ({
        value: e.id,
        label: e.name,
      }));
      fields.find((e) => e.name === "xa").options = options;
      setFields([...fields]);
    } catch (err) {}
  };

  const dispatch = useAppDispatch();
  const modalRef = useRef<any>();

  const activeTab = useAppSelector((state) => state.common.activeTab);
  const action = useAppSelector((state) => state.receive);
  const handleNewPatient = async () => {
    dispatch(
      setPatientRecord({
        selected: false,
        record: null,
      })
    );
    dispatch(
      setAction({
        actionType: RECEIVE_ACTION_TYPE.BENHNHANMOI,
        dataPassing: {
          isClear: true,
          danToc: 0,
          ngheNghiep: "Nghề khác",
        },
      })
    );
    dispatch(setActiveKey(tabKeys.RECEIVE.TAB_2));
  };

  useEffect(() => {
    if (activeTab === tabKeys.RECEIVE.TAB_1) {
      dispatch(
        setAction({
          actionType: RECEIVE_ACTION_TYPE.NORMAL,
          dataPassing: {
            isClear: true,
          },
        })
      );
    }
  }, [activeTab]);

  const handleNewExamBill = async () => {
    if (!idPhieuKham) {
      Notification("warning", "Chọn bệnh nhân để tạo phiếu khám mới");
    } else {
      dispatch(
        setAction({
          actionType: RECEIVE_ACTION_TYPE.PHIEUKHAMMOI,
          dataPassing: {
            id: action.dataPassing.id,
            anh: action.dataPassing.anh,
            idBenhNhan: action.dataPassing.idBenhNhan,
          },
        })
      );
      dispatch(setActiveKey(tabKeys.RECEIVE.TAB_2));
    }
  };

  const setShowColumns = (showColumns) => {
    saveTableOptions(
      "RECEIVED_TABLE",
      localStorage.getItem("username"),
      showColumns
    );
    setColumns(showColumns);
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await medicalExaminationService.getListMedicalBill(
        formatParams()
      );
      const newRes = response.data.data.map((e) => ({
        ...e,
        key: e.id,
      }));

      setData(newRes);
      setTotal(response.data.total);
      setLoading(false);
    } catch (error) {
      setData([]);
      setLoading(false);
      Notification("error", "Lấy dữ liệu thất bại!");
    }
  };

  const onSelectRow = (selectedRowKeys: React.Key[], selectedRows: any[]) => {
    setSelectedRowKeys([selectedRowKeys?.[selectedRowKeys?.length - 1]]);
    if (selectedRows.length == 0) {
      dispatch(setIdPhieuKham(null));
      dispatch(
        setAction({
          actionType: null,
          dataPassing: null,
        })
      );
    } else {
      dispatch(setIdPhieuKham(selectedRows[0].id));
      dispatch(
        setPatientRecord({
          selected: true,
          record: selectedRows[0],
        })
      );
      if (selectedRows[0].id) {
        getPKById(selectedRows[0].id);
      } else {
        dispatch(
          setAction({
            actionType: RECEIVE_ACTION_TYPE.EDITPHIEUKHAM,
            dataPassing: { ...selectedRows[0] },
          })
        );
      }
    }
  };

  useEffect(() => {
    if (activeTab == tabKeys.RECEIVE.TAB_1) {
      dispatch(
        setButtonsHeader([
          NewPatientBtn(handleNewPatient),
          NewExamBillBtn(handleNewExamBill),
        ])
      );
      // dispatch(
      //   setAction({
      //     actionType: RECEIVE_ACTION_TYPE.BENHNHANMOI,
      //     dataPassing: {
      //       isClear: true,
      //       danToc: 0,
      //       ngheNghiep: "Nghề khác",
      //     },
      //   })
      // );
    }
  }, [activeTab, idPhieuKham, action]);

  useEffect(() => {
    if (!localStorage.getItem("listCommueNew")) {
      fetchProvinces();
    }
  }, []);

  const formatParams = () => {
    return {
      ...params,
      ngaySinh: formatDateToString(params.ngaySinh),
      ngayTaoTu: formatDateToString(params.ngayTaoTu),
      ngayTaoDen: formatDateToString(params.ngayTaoDen),
    };
  };

  useEffect(() => {
    fetchData();
  }, [activeTab, params]);

  const onChangePagination = (page: number, pageSize: number) => {
    setPage(page);
    setLimit(pageSize);
  };

  const onClickSearchButton = () => {
    const searchFields = expandRef.current?.getData();

    setParams({
      ...params,
      ...searchFields,
      page: 1,
    });
    setPage(1);
  };
  const onToday = (key: number) => {
    setLoading(true);
    let today = dayjs();
    expandRef.current?.setFieldValue("ngayTaoTu", today);
    expandRef.current?.setFieldValue("ngayTaoDen", today);
    setParams({ ...params, ...expandRef.current?.getData() });
    setSelectedBtn(key);
  };

  const onYesterday = (key: number) => {
    setLoading(true);
    let yesterday = dayjs().subtract(1, "day");
    expandRef.current?.setFieldValue("ngayTaoTu", yesterday);
    expandRef.current?.setFieldValue("ngayTaoDen", yesterday);
    setParams({
      ...params,
      ...expandRef.current?.getData(),
    });

    setSelectedBtn(key);
  };
  const label = [
    {
      key: 1,
      value: "Hôm nay",
      onclick: (e) => onToday(e),
    },
    {
      key: 2,
      value: "Hôm qua",
      onclick: (e) => onYesterday(e),
    },
  ];

  const onKeyDown = async (e) => {
    if (e.key === "Enter") {
      await setTimeout(() => {
        onClickSearchButton();
      }, 500);
    }
  };
  //XUất báo cáo
  const getReportFile = async () => {
    const param = formatParams();

    if (param?.start != null || param.end !== null) {
      exportFile(
        "/qlkhambenh/phieu-kham/export-list-phieu-kham-da-tiep-nhan",
        formatParams(),
        `Báo cáo tiếp nhận`
      );
    } else {
      Notification("error", "");
    }
  };

  // useEffect(() => {
  //   CheckNullApi();
  // }, []);
  return (
    <Row className="received-container" onKeyDown={onKeyDown}>
      <div className="container" style={{ width: "100%" }}>
        <Space direction="vertical" style={{ width: "100%" }}>
          <ExpandSearch
            ref={expandRef}
            onClickSearch={onClickSearchButton}
            fields={fields}
            onReset={onClickSearchButton}
            initialValues={params}
          ></ExpandSearch>
        </Space>
      </div>

      <Row className="container">
        <Space direction="vertical" style={{ width: "100%" }}>
          <Row justify={"end"} gutter={[16, 16]}>
            <Space>
              {label.map((item) => (
                <Button
                  key={item.key}
                  onClick={() => {
                    item.onclick(item.key);
                  }}
                  className={
                    item.key === selectedBtn ? "btn-sub" : "custom-btn"
                  }
                  icon={
                    item.key === selectedBtn ? (
                      <CalendarSelectedSVG />
                    ) : (
                      <CalendarSVG />
                    )
                  }
                >
                  {item.value}
                </Button>
              ))}
              <Popover
                trigger="click"
                placement="topLeft"
                content={
                  <ColumnPopoverDisplay
                    setShowColumns={setShowColumns}
                    columns={defaultColumns}
                  ></ColumnPopoverDisplay>
                }
              >
                <Button className="btn-sub" icon={<ListIconSVG />}>
                  Cột hiển thị
                </Button>
              </Popover>
              <ButtonExcel onClick={getReportFile}></ButtonExcel>
            </Space>
          </Row>
          <CustomResizableTable
            setShowColumns={setShowColumns}
            bordered
            columns={columns}
            dataSource={data}
            scroll={{ x: 1500 }}
            pagination={{
              position: ["bottomRight"],
              showSizeChanger: true,
              // total: total,
              onChange: onChangePagination,
              current: page,
              pageSize: limit,
            }}
            loading={loading}
            rowSelection={{
              onChange: onSelectRow,
              selectedRowKeys: selectedRowKeys,
              hideSelectAll: true,
              selections: [Table.SELECTION_NONE],
            }}
            onRow={(record, rowIndex) => {
              return {
                onDoubleClick: (e) => {
                  handleEdit(record);
                },
              };
            }}
          />
          <ExanRegBill modalRef={modalRef} />
        </Space>
      </Row>
    </Row>
  );
};

export default Received;
